(ns pfo.widget.calendar
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.time :refer [now-js-date]]))

(defn calendar [options]
  (let [calendar-id (identity "calendar")
        calendar-id-ref (str "#" calendar-id)
        title (atom "")
        hide-header-buttons? (or (:hide-header-buttons? options) false)
        calendar-instance (fn [& opts]
                            (let [js-opts (clj->js opts)]
                              (case (count opts)
                                1 (.fullCalendar (js/$ calendar-id-ref) (nth opts 0))
                                2 (.fullCalendar (js/$ calendar-id-ref) (nth opts 0) (nth opts 1)))))]
    (reagent/create-class
      {:reagent-render
       (fn [options] [:div.c-calendar

                      (when-not hide-header-buttons?
                        [:div
                         [:h2.u-text-align-center @title]

                         [:div.o-space-between.o-margin-top-bottom
                          [:button.calendar-previous {:on-click #(calendar-instance "prev")} "Previous"]

                          [:div.o-margin-elements--medium
                           [:button {:on-click #(calendar-instance "changeView" "month") } "Month"]
                           [:button {:on-click #(calendar-instance "changeView" "agendaWeek") } "Week"]
                           [:button {:on-click #(calendar-instance "changeView" "agendaDay")} "Day"]
                           [:button {:on-click #(calendar-instance "today") } "Today"]]

                          [:button.calendar-next {:on-click #(calendar-instance "next")} "Next"]]]) 
                      
                      [:div.calendar-widget {:id calendar-id}]])

       :component-did-mount (fn [_]
                              (calendar-instance (clj->js (merge
                                                            {:header (or (:header options) false)
                                                             :defaultDate (or (:defaultDate options) (now-js-date))
                                                             :viewRender (fn [view element]
                                                                           (reset! title (.-title view)))
                                                             :eventClick (:event-click options)
                                                             :dayClick (:day-click options)}
                                                            options))))})))
